module.exports = __webpack_public_path__ + "static/WINNERS-photo-8d66222421264aec093f3bc9022a4733.jpg";